import { PharmacyBar as Bar, PharmacyDoughnut as Doughnut, PharmacySelect, PharmacyPagination, PharmacyDownloadDialog, PharmacyMetric, PharmacyTabs } from './shared/PharmacyUI';
import React, { useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { Box, Typography, CircularProgress, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import { HeaderIOS, IOS } from './shared/MenuLayout';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement,
  LineElement, BarElement, ArcElement, Tooltip as ChartTooltip, Legend, Filler
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, ChartTooltip, Legend, Filler);

// ── Indicadores config unificada ──────────────────────────────────────────────
const IND_CFG = {
  'SOBRESTOCK':   { bg:'#EDFAF2', border:'#B7EFD0', text:'#1A6B3C', dot:'#34C759' },
  'NORMOSTOCK':   { bg:'#EDFAF2', border:'#B7EFD0', text:'#1A6B3C', dot:'#22C55E' },
  'SUBSTOCK':     { bg:'#FFF8E6', border:'#FFE9A0', text:'#8B6914', dot:'#FF9500' },
  'DESABASTECIDO':{ bg:'#FFF0EF', border:'#FFD4D1', text:'#C0392B', dot:'#FF3B30' },
  'SIN ROTACION': { bg:'#F2F2F7', border:'#D1D1D6', text:'#636366', dot:'#8E8E93' },
  'SIN CONSUMO':  { bg:'#F2F2F7', border:'#D1D1D6', text:'#636366', dot:'#8E8E93' },
  'NO APLICA':    { bg:'#F0EFFF', border:'#C7C7F0', text:'#3730A3', dot:'#5E5CE6' },
};
const getInd = (v) => IND_CFG[v?.toUpperCase()] || { bg:IOS.bg, border:IOS.separator, text:IOS.label2, dot:IOS.label3 };

const COL_LABELS = {
  'CODIGO_MED':'Código','PRODUCTO':'Producto','FM_codigo_sig':'Cód. SIGA',
  'TOTAL_VENTA':'Venta','TOTAL_SIS':'SIS','TOTAL_INTERSAN':'Inter. San.',
  'TOTAL_DEFHAC':'Def. Nac.','TOTAL_EXO':'Exonerado','TOTAL_SOAT':'SOAT',
  'TOTAL_CREDHOSP':'Cred. Hosp.','TOTAL_OTR_CONV':'Otros Conv.',
  'OTRAS_SALIDAS':'Otras Salidas','TOTAL_GENERAL':'Total',
};

const fmtP = (p) => (!p||p.toString().length<6)?'':`${p.toString().substring(4,6)}/${p.toString().substring(0,4)}`;

// ── IndPill ───────────────────────────────────────────────────────────────────
const IndPill = ({ valor }) => {
  const cfg = getInd(valor);
  return (
    <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5,
      px:0.8, py:0.25, borderRadius:'20px', bgcolor:cfg.bg, border:`1px solid ${cfg.border}` }}>
      <Box sx={{ width:5, height:5, borderRadius:'50%', bgcolor:cfg.dot, flexShrink:0 }} />
      <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:cfg.text, whiteSpace:'nowrap' }}>{valor||'—'}</Typography>
    </Box>
  );
};

// ── Sel ───────────────────────────────────────────────────────────────────────
const Sel = PharmacySelect;

// ── Paginación iOS ────────────────────────────────────────────────────────────
const Paginacion = PharmacyPagination;

// ── Modal exportar iOS ────────────────────────────────────────────────────────
const ModalExportar = ({ open, onClose, tipo, total, onExportar, exportando }) => (<PharmacyDownloadDialog open={open} onClose={onClose} total={total} busy={exportando} options={[{fmt:'pdf',label:'Descargar PDF',onClick:()=>onExportar('pdf')},{fmt:'excel',label:'Descargar Excel',onClick:()=>onExportar('excel')}]}/>);

// ── KPI indicador card ────────────────────────────────────────────────────────
const KpiInd=({ind,count,total})=><PharmacyMetric label={ind} value={count.toLocaleString()} color={getInd(ind).dot} progress={total?count/total*100:0} sub={(total?(count/total*100).toFixed(1):'0')+'% del total'}/>;

// ═════════════════════════════════════════════════════════════════════════════
const FMT_S = (v) => `S/ ${Number(v||0).toLocaleString('es-PE',{minimumFractionDigits:2})}`;
const FMT_N = (v) => Number(v||0).toLocaleString('es-PE',{minimumFractionDigits:0});

const FP_COLS = [
  { key:'TOTAL_VENTA',    label:'Contado',       color:'#34C759' },
  { key:'TOTAL_SIS',      label:'SIS',           color:'#007AFF' },
  { key:'TOTAL_INTERSAN', label:'Inter. San.',   color:'#5E5CE6' },
  { key:'TOTAL_DEFHAC',   label:'Def. Nac.',     color:'#FF9500' },
  { key:'TOTAL_EXO',      label:'Exonerado',     color:'#FF2D55' },
  { key:'TOTAL_SOAT',     label:'SOAT',          color:'#FF3B30' },
  { key:'TOTAL_CREDHOSP', label:'Cred. Hosp.',   color:'#30B0C7' },
  { key:'TOTAL_OTR_CONV', label:'Otros Conv.',   color:'#BF5AF2' },
  { key:'OTRAS_SALIDAS',  label:'Otras Salidas', color:'#8E8E93' },
];

const AlmacenConsumo = () => {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();
  const ueId = user?.ueIdEstablecimiento || user?.UeIdEstablecimiento || 0;
  const idEstabUsuario = String(user?.idEstablecimiento||user?.IdEstablecimiento||0);

  const [privConsumos, setPrivConsumos] = useState('Solo lectura');
  useEffect(()=>{
    api.get('/dashboard/permisos').then(r=>{
      if(r.data.success){
        const op = r.data.opciones.find(o=>(o.permiso||'').toLowerCase().includes('consumos'));
        if(op) setPrivConsumos(op.privilegio||'Solo lectura');
      }
    }).catch(()=>{});
  },[]);
  const esTOTAL = privConsumos === 'Total';

  const [tab, setTab] = useState(0);

  // Consolidado
  const [ipressList, setIpressList]   = useState([]);
  const [ipressSel, setIpressSel]     = useState('');
  const [perIni, setPerIni]           = useState('202501');
  const [perFin, setPerFin]           = useState('');
  const [consolidado, setConsolidado] = useState([]);
  const [loadCon, setLoadCon]         = useState(false);
  const [pgCon, setPgCon]             = useState(1);
  const [rppCon, setRppCon]           = useState(50);
  const [busqCon, setBusqCon]         = useState('');

  const [tipoGrafFP, setTipoGrafFP] = useState('bar');
  const [fpActivas, setFpActivas]   = useState(FP_COLS.map(f=>f.key));

  // Modal exportar
  const [modalExp, setModalExp]       = useState({ open:false, tipo:null });
  const [exportando, setExportando]   = useState(false);

  const handleLogout = () => { authService.logout(); navigate('/login'); };

  const generarPeriodos = () => {
    const list=[], now=new Date();
    const periodoMax = now.getMonth()===0 ? (now.getFullYear()-1)*100+12 : now.getFullYear()*100+now.getMonth();
    let p = 202501;
    while (p <= periodoMax) {
      list.push(p);
      const ay=Math.floor(p/100), am=p%100;
      p = am===12?(ay+1)*100+1:ay*100+am+1;
    }
    return list;
  };

  useEffect(() => {
    const now=new Date(), m=now.getMonth(), y=now.getFullYear();
    setPerFin(m===0?`${y-1}12`:`${y}${String(m).padStart(2,'0')}`);
    if(!privConsumos) return;
    api.get(`/farmacia/consumo/listar-ipress?ueId=${ueId}`)
      .then(r=>{
        if(r.data.success&&r.data.data.length){
          const lista = r.data.data;
          const mi = lista.find(ip=>String(ip.id_establecimiento)===idEstabUsuario)||lista[0];
          if(esTOTAL){ setIpressList(lista); setIpressSel(mi.id_establecimiento); }
          else { setIpressList([mi]); setIpressSel(mi.id_establecimiento); }
        }
      }).catch(console.error);
  }, [ueId, privConsumos]);


  const procesarConsolidado = async () => {
    setLoadCon(true);
    try {
      const ipressObj = ipressList.find(i=>i.id_establecimiento==ipressSel);
      const nombre = ipressObj?.nombre?.toUpperCase()||'';
      const tipoEntidad = nombre.includes('TODOS')?'T':nombre.includes('UNIDAD EJECUTORA')?'U':'I';
      const r = await api.get('/farmacia/consumo/consolidado', { params:{ tipoEntidad, idEntidad:ipressSel, ueId, periodoInicio:perIni, periodoFin:perFin } });
      if(r.data.success){ setConsolidado(r.data.data); setPgCon(1); }
    } catch(e){ console.error(e); } finally { setLoadCon(false); }
  };


  const handleExportar = async (fmt) => {
    setExportando(true);
    try {
      const mime = fmt==='pdf'?'application/pdf':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const ext  = fmt==='pdf'?'pdf':'xlsx';
      const tipo = modalExp.tipo;
      const endpoint = `/farmacia/consumo/exportar-consolidado-${fmt}`;
      const datos  = consolidado;
      const filtros = { ipress:ipressList.find(i=>i.id_establecimiento==ipressSel)?.nombre||'', periodoInicio:perIni, periodoFin:perFin };
      const r = await api.post(endpoint, { datos, filtros }, { responseType:'blob' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([r.data],{type:mime}));
      a.download = `ConsumoConsolidado_${perIni}_${perFin}.${ext}`;
      a.click(); URL.revokeObjectURL(a.href);
      setModalExp({ open:false, tipo:null });
    } catch(e){ console.error(e); } finally { setExportando(false); }
  };

  const conFiltrado = busqCon.length>=2
    ? consolidado.filter(r=>(r.PRODUCTO||'').toLowerCase().includes(busqCon.toLowerCase())||(r.CODIGO_MED||'').toLowerCase().includes(busqCon.toLowerCase()))
    : consolidado;
  const conPag = conFiltrado.slice((pgCon-1)*rppCon, pgCon*rppCon);

  // KPIs analisis
  const kpiTotal    = useMemo(()=>consolidado.reduce((s,r)=>s+Number(r.TOTAL_GENERAL||0),0),[consolidado]);
  const kpiValor    = useMemo(()=>consolidado.reduce((s,r)=>s+Number(r.VALORIZADO||0),0),[consolidado]);
  const kpiOtrasSal = useMemo(()=>consolidado.reduce((s,r)=>s+Number(r.OTRAS_SALIDAS||0),0),[consolidado]);
  const kpiProds    = consolidado.length;

  // Top 10 productos
  const top10 = useMemo(()=>[...consolidado]
    .sort((a,b)=>Number(b.TOTAL_GENERAL||0)-Number(a.TOTAL_GENERAL||0))
    .slice(0,10)
    .map(r=>({ nombre:(r.PRODUCTO||'').substring(0,35), total:Number(r.TOTAL_GENERAL||0), valor:Number(r.VALORIZADO||0) }))
  ,[consolidado]);

  // Distribucion FP
  const distFP = useMemo(()=>FP_COLS.map(fp=>({
    ...fp, total: consolidado.reduce((s,r)=>s+Number(r[fp.key]||0),0)
  })).filter(fp=>fp.total>0),[consolidado]);

  return (
    <Box className="pharmacy-page" sx={{ minHeight:'100vh', bgcolor:IOS.bg }}>
      <HeaderIOS titulo="Consumo" subtitulo="Farmacia"
        onHome={()=>navigate('/farmacia')} onLogout={handleLogout}
        nombreCompleto={user?.nombreCompleto||user?.usuario||''}
        avatarLetra={(user?.nombreCompleto||user?.usuario||'U').charAt(0).toUpperCase()} />

      {/* Tabs */}
      <Box className="pharmacy-tabs-row"><PharmacyTabs value={tab} onChange={setTab} options={['Consumo Consolidado','Análisis']}/></Box>

      <Box className="pharmacy-content" sx={{ maxWidth:1600, mx:'auto', px:{ xs:1.5, sm:2.6 }, pt:2.5, pb:6 }}>

        {/* ══ TAB 0: CONSUMO CONSOLIDADO ══════════════════════════════════ */}
        {tab===0 && (
          <Box>
            {/* Filtros */}
            <Box className="pharmacy-layout pharmacy-toolbar pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:2,
              boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`,
              mb:2.5, display:'flex', gap:2, flexWrap:'wrap', alignItems:'flex-end' }}>
              {esTOTAL
                ? <Sel label="IPRESS" value={ipressSel} onChange={e=>setIpressSel(e.target.value)} disabled={loadCon} w={{ xs:'100%', sm:260 }}>
                    {ipressList.map((ip,i)=><option key={i} value={ip.id_establecimiento}>{ip.nombre}</option>)}
                  </Sel>
                : <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3, width:{ xs:'100%', sm:'auto' } }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>IPRESS</Typography>
                    <Box className="pharmacy-layout" sx={{ height:34, px:1.5, display:'flex', alignItems:'center', border:`1px solid ${IOS.separator}`, borderRadius:'8px', bgcolor:IOS.bg, minWidth:{ xs:'100%', sm:260 } }}>
                      <Typography sx={{ fontSize:'0.8rem', color:IOS.label2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{ipressList[0]?.nombre||'Cargando...'}</Typography>
                    </Box>
                  </Box>
              }
              <Sel label="Período Inicio" value={perIni} onChange={e=>setPerIni(e.target.value)} disabled={loadCon} w={{ xs:'calc(50% - 8px)', sm:120 }}>
                {generarPeriodos().map(p=><option key={p} value={p.toString()}>{fmtP(p)}</option>)}
              </Sel>
              <Sel label="Período Fin" value={perFin} onChange={e=>setPerFin(e.target.value)} disabled={loadCon} w={{ xs:'calc(50% - 8px)', sm:120 }}>
                {generarPeriodos().map(p=><option key={p} value={p.toString()}>{fmtP(p)}</option>)}
              </Sel>
              {/* Botón procesar */}
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={procesarConsolidado} disabled={loadCon}
                sx={{ height:34, px:2.5, borderRadius:'10px', border:'none', alignSelf:'flex-end', width:{ xs:'100%', sm:'auto' },
                  bgcolor:IOS.blue, cursor:loadCon?'wait':'pointer', display:'flex',
                  alignItems:'center', justifyContent:'center', gap:0.8, transition:'all 0.2s',
                  '&:hover':{ filter:'brightness(0.92)' } }}>
                {loadCon
                  ? <CircularProgress size={13} sx={{ color:'white' }} />
                  : <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>}
                <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:'white' }}>
                  {loadCon?'Procesando…':'Procesar'}
                </Typography>
              </Box>
              <Box className="pharmacy-layout" sx={{ ml:{ xs:0, sm:'auto' }, width:{ xs:'100%', sm:'auto' }, display:'flex', alignItems:'center', justifyContent:{ xs:'space-between', sm:'flex-end' }, gap:1.5 }}>
                {/* Contador */}
                <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:0.8, px:1.5, py:0.6,
                  bgcolor:IOS.bg, borderRadius:'20px', border:`1px solid ${IOS.separator}` }}>
                  <Box sx={{ width:7, height:7, borderRadius:'50%', bgcolor:IOS.green }} />
                  <Typography sx={{ fontSize:'0.72rem', fontWeight:600, color:IOS.label2 }}>
                    {consolidado.length.toLocaleString()} registros
                  </Typography>
                </Box>
                {/* Exportar */}
                {consolidado.length>0 && (
                  <Box className="pharmacy-layout pharmacy-action" aria-label="Descargar reporte" component="button" onClick={()=>setModalExp({ open:true, tipo:'consolidado' })}
                    sx={{ width:34, height:34, borderRadius:'50%', border:'none',
                      bgcolor:IOS.green, cursor:'pointer', display:'flex',
                      alignItems:'center', justifyContent:'center', transition:'all 0.15s',
                      '&:hover':{ filter:'brightness(0.9)', transform:'scale(1.05)' } }}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round">
                      <path d="M12 3v13M7 11l5 5 5-5"/><path d="M4 20h16"/>
                    </svg>
                  </Box>
                )}
              </Box>
            </Box>

            {loadCon
              ? <Box sx={{ py:12, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>
              : consolidado.length>0
                ? <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px',
                    boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, overflow:'hidden' }}>
                      <Box className="pharmacy-layout" sx={{ px:2, py:1.5, borderBottom:`1px solid ${IOS.separator}`, display:'flex', alignItems:'center', gap:1.5 }}>
                      <Box sx={{ position:'relative', flex:1, maxWidth:320 }}>
                        <Box sx={{ position:'absolute', left:9, top:'50%', transform:'translateY(-50%)', color:IOS.label2, pointerEvents:'none' }}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                        </Box>
                        <input type="text" placeholder="Buscar producto o código..." value={busqCon}
                          onChange={e=>{setBusqCon(e.target.value);setPgCon(1);}}
                          style={{ width:'100%', height:34, paddingLeft:28, paddingRight:10,
                            border:`1px solid ${IOS.separator}`, borderRadius:8, fontSize:'0.8rem',
                            color:IOS.label, backgroundColor:IOS.surface, outline:'none',
                            boxSizing:'border-box', fontFamily:'inherit' }}
                          onFocus={e=>e.target.style.borderColor=IOS.blue}
                          onBlur={e=>e.target.style.borderColor=IOS.separator}/>
                      </Box>
                      <Typography sx={{ fontSize:'0.72rem', color:IOS.label2 }}>
                        {conFiltrado.length.toLocaleString()} de {consolidado.length.toLocaleString()} registros
                      </Typography>
                    </Box>
                    {/* Móvil — cards */}
                    <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{ display:{ xs:'block', md:'none' }, maxHeight:'calc(100vh - 320px)', overflowY:'auto',
                      '&::-webkit-scrollbar':{ width:3 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
                      {conPag.map((row,i)=>(
                        <Box key={i} sx={{ p:2, borderBottom:`1px solid ${IOS.separator}` }}>
                          <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:1, mb:1 }}>
                            <Box sx={{ minWidth:0 }}>
                              <Typography sx={{ fontWeight:700, fontSize:'0.8rem', color:'#1F2937', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{row.PRODUCTO||'—'}</Typography>
                              <Typography sx={{ fontSize: '0.72rem', color:IOS.label2, fontFamily:'monospace' }}>{row.CODIGO_MED} {row.FM_codigo_sig?`· SIGA ${row.FM_codigo_sig}`:''}</Typography>
                            </Box>
                            <Box sx={{ textAlign:'right', flexShrink:0 }}>
                              <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, textTransform:'uppercase' }}>Total</Typography>
                              <Typography sx={{ fontSize:'0.9rem', fontWeight:800, color:IOS.blue }}>{FMT_N(row.TOTAL_GENERAL)}</Typography>
                            </Box>
                          </Box>
                          <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:0.6 }}>
                            {[['SIS',row.TOTAL_SIS],['Inter.San.',row.TOTAL_INTERSAN],['Def.Nac.',row.TOTAL_DEFHAC],
                              ['Exon.',row.TOTAL_EXO],['SOAT',row.TOTAL_SOAT],['Cred.Hosp.',row.TOTAL_CREDHOSP],
                              ['Otr.Conv.',row.TOTAL_OTR_CONV],['Otras Sal.',row.OTRAS_SALIDAS],['Contado',row.TOTAL_VENTA]]
                              .map(([l,v],j)=>(
                              <Box key={j} sx={{ bgcolor:IOS.bg, borderRadius:'8px', px:0.5, py:0.5, textAlign:'center' }}>
                                <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, textTransform:'uppercase' }}>{l}</Typography>
                                <Typography sx={{ fontSize:'0.72rem', fontWeight:700, color:Number(v)>0?IOS.label:IOS.label3 }}>{Number(v)>0?FMT_N(v):'—'}</Typography>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      ))}
                    </Box>

                    {/* Desktop — tabla */}
                    <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{ display:{ xs:'none', md:'block' }, overflowX:'auto', overflowY:'auto', maxHeight:'calc(100vh - 320px)',
                      '&::-webkit-scrollbar':{ width:4, height:4 },
                      '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
                      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.75rem' }}>
                        <thead>
                          <tr>
                            {Object.keys(consolidado[0]||{}).map((col,i)=>(
                              <th key={i} style={{ padding:'9px 12px', textAlign:'left',
                                fontSize: '0.72rem', fontWeight:700, color:IOS.label2,
                                letterSpacing:'0.06em', textTransform:'uppercase',
                                backgroundColor:IOS.surface, borderBottom:`1px solid ${IOS.separator}`,
                                position:'sticky', top:0, whiteSpace:'nowrap', zIndex:1 }}>
                                {COL_LABELS[col]||col}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {conPag.map((row,i)=>(
                            <tr key={i} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:IOS.surface, transition:'background 0.1s' }}
                              onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                              onMouseLeave={e=>e.currentTarget.style.backgroundColor=IOS.surface}>
                              {Object.values(row).map((val,j)=>(
                                <td key={j} style={{ padding:'8px 12px', fontSize:'0.73rem', color:IOS.label }}>
                                  {val!==null&&val!==undefined?val.toString():'—'}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Box>
                    <Paginacion total={conFiltrado.length} pagina={pgCon} setPagina={setPgCon} rpp={rppCon} setRpp={setRppCon} />
                  </Box>
                : <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', py:8, textAlign:'center',
                    border:`1px solid ${IOS.separator}` }}>
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" style={{ opacity:0.2 }}
                      stroke={IOS.label} strokeWidth="1.5" strokeLinecap="round">
                      <rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/>
                    </svg>
                    <Typography sx={{ mt:1.5, fontWeight:600, color:IOS.label, fontSize:'0.88rem', mb:0.5 }}>Sin datos</Typography>
                    <Typography sx={{ color:IOS.label2, fontSize:'0.78rem' }}>Configura los parámetros y presiona Procesar</Typography>
                  </Box>
            }
          </Box>
        )}

        {/* ══ TAB 1: ANÁLISIS ══════════════════════════════════════════════ */}
        {tab===1 && (
          consolidado.length===0
            ? <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', py:10, textAlign:'center', border:`1px solid ${IOS.separator}` }}>
                <Box className="pharmacy-layout" sx={{ width:60, height:60, borderRadius:'50%', bgcolor:`${IOS.blue}12`, display:'flex', alignItems:'center', justifyContent:'center', mx:'auto', mb:2 }}>
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>
                </Box>
                <Typography sx={{ fontWeight:700, fontSize:'0.95rem', color:IOS.label, mb:0.5 }}>Sin datos para analizar</Typography>
                <Typography sx={{ color:IOS.label2, fontSize:'0.82rem' }}>Ve a Consumo Consolidado y procesa un período primero</Typography>
              </Box>
            : <Box>
                {/* KPIs */}
                <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr 1fr', sm:'repeat(4,1fr)' }, gap:1.5, mb:2.5 }}>
                  {[
                    { label:'Total Unidades', valor:FMT_N(kpiTotal), sub:`${kpiProds} productos`, color:IOS.blue,
                      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> },
                    { label:'Valorizado Total', valor:FMT_S(kpiValor), sub:'S/ por precio unitario', color:IOS.green,
                      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="1.8" strokeLinecap="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg> },
                    { label:'Otras Salidas', valor:FMT_N(kpiOtrasSal), sub:'Dev + Venc + Merma + Dist', color:IOS.orange,
                      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="1.8" strokeLinecap="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> },
                    { label:'Productos únicos', valor:kpiProds.toLocaleString(), sub:'en el período', color:'#5E5CE6',
                      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#5E5CE6" strokeWidth="1.8" strokeLinecap="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg> },
                  ].map(({ label, valor, sub, color, icon })=>(
                    <PharmacyMetric key={label} label={label} value={valor} sub={sub} color={color} icon={icon} />
                  ))}
                </Box>

                {/* Gráficos grid */}
                <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr', lg:'1fr 1fr' }, gap:2, mb:2 }}>

                  {/* Gráfico FP */}
                  <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:{ xs:1.8, sm:2.5 }, boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}` }}>
                    <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', mb:2 }}>
                      <Box>
                        <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:IOS.label }}>Distribución por Forma de Pago</Typography>
                        <Typography sx={{ fontSize:'0.7rem', color:IOS.label2, mt:0.2 }}>Unidades totales por FP</Typography>
                      </Box>
                      <Box className="pharmacy-layout" sx={{ display:'flex', gap:0.4, bgcolor:IOS.bg, borderRadius:'10px', p:0.4 }}>
                        {[
                          { key:'bar',      icon:<><rect x="3" y="10" width="4" height="8" rx="1" fill="currentColor" opacity=".9"/><rect x="10" y="6" width="4" height="12" rx="1" fill="currentColor" opacity=".9"/><rect x="17" y="3" width="4" height="15" rx="1" fill="currentColor" opacity=".9"/></> },
                          { key:'doughnut', icon:<><circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="3"/><circle cx="12" cy="12" r="4" fill="currentColor" opacity=".3"/></> },
                        ].map(({key,icon})=>(
                          <Box className="pharmacy-layout" key={key} onClick={()=>setTipoGrafFP(key)}
                            sx={{ width:28, height:28, borderRadius:'8px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', transition:'all 0.15s',
                              bgcolor:tipoGrafFP===key?IOS.surface:'transparent',
                              boxShadow:tipoGrafFP===key?'0 1px 3px rgba(0,0,0,0.12)':'none',
                              color:tipoGrafFP===key?IOS.blue:IOS.label2 }}>
                            <svg width="16" height="16" viewBox="0 0 24 24">{icon}</svg>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{ height:260 }}>
                      {tipoGrafFP==='doughnut'
                        ? <Doughnut
                            data={{
                              labels: distFP.map(f=>f.label),
                              datasets:[{ data: distFP.map(f=>f.total), backgroundColor: distFP.map(f=>f.color), borderWidth:0, hoverOffset:8 }]
                            }}
                            options={{
                              responsive:true, maintainAspectRatio:false, cutout:'60%',
                              plugins:{ datalabels:{display:false}, legend:{position:'bottom',labels:{usePointStyle:true,pointStyle:'circle',padding:12,color:IOS.label2,font:{size:10}}},
                                tooltip:{backgroundColor:IOS.surface,titleColor:IOS.label,bodyColor:IOS.label2,borderColor:IOS.separator,borderWidth:1,padding:10,cornerRadius:10,
                                  callbacks:{label:ctx=>` ${ctx.label}: ${FMT_N(ctx.raw)} un.`}} }
                            }}
                          />
                        : <Bar
                            data={{
                              labels: distFP.filter(f=>fpActivas.includes(f.key)).map(f=>f.label),
                              datasets:[{ data: distFP.filter(f=>fpActivas.includes(f.key)).map(f=>f.total),
                                backgroundColor: distFP.filter(f=>fpActivas.includes(f.key)).map(f=>f.color),
                                borderRadius:6, borderWidth:0, datalabels:{display:false} }]
                            }}
                            options={{
                              responsive:true, maintainAspectRatio:false,
                              plugins:{ datalabels:{display:false}, legend:{display:false},
                                tooltip:{backgroundColor:IOS.surface,titleColor:IOS.label,bodyColor:IOS.label2,borderColor:IOS.separator,borderWidth:1,padding:10,cornerRadius:10,
                                  callbacks:{label:ctx=>` ${ctx.dataset.label||''}: ${FMT_N(ctx.raw)} un.`}} },
                              scales:{ x:{grid:{display:false},ticks:{font:{size:9},color:IOS.label2},border:{display:false}},
                                y:{grid:{color:'rgba(60,60,67,0.05)'},border:{display:false},ticks:{font:{size:9},color:IOS.label2}} }
                            }}
                          />
                      }
                    </Box>
                    {tipoGrafFP==='bar' && (
                      <Box className="pharmacy-layout" sx={{ display:'flex', gap:0.5, flexWrap:'wrap', mt:1.5 }}>
                        {FP_COLS.map(fp=>{
                          const activa = fpActivas.includes(fp.key);
                          return (
                            <Box className="pharmacy-layout" key={fp.key} onClick={()=>setFpActivas(prev=>prev.includes(fp.key)?prev.filter(k=>k!==fp.key):[...prev,fp.key])}
                              sx={{ display:'flex', alignItems:'center', gap:0.5, px:0.8, py:0.3, borderRadius:'20px', cursor:'pointer', transition:'all 0.15s',
                                bgcolor:activa?`${fp.color}15`:IOS.bg, border:`1px solid ${activa?fp.color:IOS.separator}`, opacity:activa?1:0.4 }}>
                              <Box sx={{ width:6, height:6, borderRadius:'50%', bgcolor:activa?fp.color:IOS.label3, flexShrink:0 }}/>
                              <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:activa?fp.color:IOS.label3 }}>{fp.label}</Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    )}
                  </Box>

                  {/* Top 10 productos */}
                  <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:{ xs:1.8, sm:2.5 }, boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}` }}>
                    <Box sx={{ mb:2 }}>
                      <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:IOS.label }}>Top 10 Productos</Typography>
                      <Typography sx={{ fontSize:'0.7rem', color:IOS.label2, mt:0.2 }}>Por total de unidades consumidas</Typography>
                    </Box>
                    <Box sx={{ height:260 }}>
                      <Bar
                        data={{
                          labels: top10.map(r=>r.nombre),
                          datasets:[{
                            label:'Unidades',
                            data: top10.map(r=>r.total),
                            backgroundColor: IOS.blue,
                            borderRadius:6, borderWidth:0, datalabels:{display:false}
                          }]
                        }}
                        options={{
                          responsive:true, maintainAspectRatio:false, indexAxis:'y',
                          plugins:{ datalabels:{display:false}, legend:{display:false},
                            tooltip:{backgroundColor:IOS.surface,titleColor:IOS.label,bodyColor:IOS.label2,borderColor:IOS.separator,borderWidth:1,padding:10,cornerRadius:10,
                              callbacks:{label:ctx=>` ${FMT_N(ctx.raw)} un.`}} },
                          scales:{ x:{grid:{color:'rgba(60,60,67,0.05)'},border:{display:false},ticks:{font:{size:9},color:IOS.label2}},
                            y:{grid:{display:false},border:{display:false},ticks:{font:{size:9},color:IOS.label2}} }
                        }}
                      />
                    </Box>
                  </Box>
                </Box>

                {/* Otras Salidas vs Consumo */}
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:{ xs:1.8, sm:2.5 }, boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, mb:2 }}>
                  <Box sx={{ mb:2 }}>
                    <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:IOS.label }}>Consumo vs Otras Salidas — Top 15</Typography>
                    <Typography sx={{ fontSize:'0.7rem', color:IOS.label2, mt:0.2 }}>Comparativo por producto (Dev + Venc + Merma + Distri)</Typography>
                  </Box>
                  <Box sx={{ height:280 }}>
                    <Bar
                      data={{
                        labels: [...consolidado]
                          .sort((a,b)=>Number(b.OTRAS_SALIDAS||0)-Number(a.OTRAS_SALIDAS||0))
                          .slice(0,15)
                          .map(r=>(r.PRODUCTO||'').substring(0,30)),
                        datasets:[
                          {
                            label:'Consumo',
                            data: [...consolidado]
                              .sort((a,b)=>Number(b.OTRAS_SALIDAS||0)-Number(a.OTRAS_SALIDAS||0))
                              .slice(0,15)
                              .map(r=>Number(r.TOTAL_GENERAL||0)),
                            backgroundColor: IOS.blue,
                            borderRadius:4, borderWidth:0, datalabels:{display:false}
                          },
                          {
                            label:'Otras Salidas',
                            data: [...consolidado]
                              .sort((a,b)=>Number(b.OTRAS_SALIDAS||0)-Number(a.OTRAS_SALIDAS||0))
                              .slice(0,15)
                              .map(r=>Number(r.OTRAS_SALIDAS||0)),
                            backgroundColor: IOS.orange,
                            borderRadius:4, borderWidth:0, datalabels:{display:false}
                          }
                        ]
                      }}
                      options={{
                        responsive:true, maintainAspectRatio:false, indexAxis:'y',
                        plugins:{ datalabels:{display:false},
                          legend:{position:'bottom',labels:{usePointStyle:true,pointStyle:'circle',padding:16,color:IOS.label2,font:{size:11}}},
                          tooltip:{backgroundColor:IOS.surface,titleColor:IOS.label,bodyColor:IOS.label2,borderColor:IOS.separator,borderWidth:1,padding:10,cornerRadius:10,
                            callbacks:{label:ctx=>` ${ctx.dataset.label}: ${FMT_N(ctx.raw)} un.`}} },
                        scales:{
                          x:{grid:{color:'rgba(60,60,67,0.05)'},border:{display:false},ticks:{font:{size:9},color:IOS.label2}},
                          y:{grid:{display:false},border:{display:false},ticks:{font:{size:9},color:IOS.label2}}
                        }
                      }}
                    />
                  </Box>
                </Box>

                {/* Top 10 valorizado */}
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:{ xs:1.8, sm:2.5 }, boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}` }}>
                  <Box sx={{ mb:2 }}>
                    <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:IOS.label }}>Top 10 Productos — Valorizado</Typography>
                    <Typography sx={{ fontSize:'0.7rem', color:IOS.label2, mt:0.2 }}>Por mayor valor en S/</Typography>
                  </Box>
                  <Box sx={{ height:220 }}>
                    <Bar
                      data={{
                        labels: [...consolidado].sort((a,b)=>Number(b.VALORIZADO||0)-Number(a.VALORIZADO||0)).slice(0,10).map(r=>(r.PRODUCTO||'').substring(0,35)),
                        datasets:[{
                          label:'Valorizado S/',
                          data: [...consolidado].sort((a,b)=>Number(b.VALORIZADO||0)-Number(a.VALORIZADO||0)).slice(0,10).map(r=>Number(r.VALORIZADO||0)),
                          backgroundColor: IOS.green, borderRadius:6, borderWidth:0, datalabels:{display:false}
                        }]
                      }}
                      options={{
                        responsive:true, maintainAspectRatio:false, indexAxis:'y',
                        plugins:{ datalabels:{display:false}, legend:{display:false},
                          tooltip:{backgroundColor:IOS.surface,titleColor:IOS.label,bodyColor:IOS.label2,borderColor:IOS.separator,borderWidth:1,padding:10,cornerRadius:10,
                            callbacks:{label:ctx=>` ${FMT_S(ctx.raw)}`}} },
                        scales:{ x:{grid:{color:'rgba(60,60,67,0.05)'},border:{display:false},ticks:{font:{size:9},color:IOS.label2,callback:v=>`S/${(v/1000).toFixed(0)}k`}},
                          y:{grid:{display:false},border:{display:false},ticks:{font:{size:9},color:IOS.label2}} }
                      }}
                    />
                  </Box>
                </Box>
              </Box>
        )}
      </Box>

      <ModalExportar
        open={modalExp.open} onClose={()=>setModalExp({ open:false, tipo:null })}
        tipo={modalExp.tipo} exportando={exportando} onExportar={handleExportar}
        total={consolidado.length} />
    </Box>
  );
};

export default AlmacenConsumo;
